import React from 'react';
import SEO from '../components/SEO';
import AssessmentExperience from '../features/assessment/AssessmentExperience';
import AssessmentRecovery from '../features/assessment/AssessmentRecovery';

const Assessment: React.FC = () => {
  const recovery = window.location.pathname === '/assessment/recovery';
  return (
    <>
      <SEO
        title={recovery ? 'Recover Your Private Assessment | Davinci AI Solutions' : 'AI Opportunity & Readiness Assessment | Davinci AI Solutions'}
        description={recovery ? 'Securely recover access to your private Davinci assessment.' : 'Assess one real workflow. Find where AI can assist, where deterministic automation belongs, and what your organization needs for a safe, measurable pilot.'}
        path={recovery ? '/assessment/recovery' : '/assessment'}
        noindex={recovery}
      />
      {recovery ? <AssessmentRecovery /> : <AssessmentExperience />}
    </>
  );
};

export default Assessment;
